<template>
    <b-carousel id="carousel-fade" v-if="result.hotel.media" controls :interval="0">
        <b-carousel-slide v-for="image in result.hotel.media" :key="image.url">
            <template v-slot:img>
                <div
                    class="gallery"
                    v-bind:style="{
                        backgroundImage: 'url(' + image.uri + ')',
                    }"
                />
            </template>
        </b-carousel-slide>
    </b-carousel>
    <div v-else class="placeholder-img"></div>
</template>

<script>
    export default {
        name: "HotelImage",
        props: ['result'],
        methods: {}
    };
</script>

<style scoped>
    .gallery {
        height:100% !important;
        width:100% !important;
        min-height: 250px;
        min-width:250px;
    }

    .gallery {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }

    .placeholder-img{
        background-image: url('~@/assets/placeholder.jpg');
        height:100%;
        width:100%;
        background-size: cover;
    }
</style>